// PROTOTYPE-ONLY — remove before production
import React from "react";

/**
 * Small gold-outlined pill that flags a UI control as a review-time
 * artifact rather than a shipped product feature.
 */
export default function PrototypeBadge({ className = "" }) {
  return (
    <span
      data-testid="prototype-badge"
      className={`inline-flex items-center px-2 py-[3px] rounded-full text-[9.5px] font-black uppercase tracking-[0.18em] border border-[#FFC107]/40 text-[#FFC107] bg-[#FFC107]/5 ${className}`}
    >
      Prototype
    </span>
  );
}
